import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProjectViewToggle.css';

// QLOG-S2.1 §A — segmented Delivery ↔ Plan toggle for the two project
// views. Rendered inside DeliveryPage (active='delivery') and
// ProjectDetailPage's readOnly (my-projects) mode (active='plan'), so
// switching between the two doesn't have to go through the list.
// Visual language mirrors the Day/Week/Month segmented control in
// My Timesheet.
export default function ProjectViewToggle({ projectId, active }) {
  const nav = useNavigate();
  const isDelivery = active === 'delivery';
  const isPlan = active === 'plan';
  const goDelivery = () => { if (!isDelivery) nav(`/my-projects/${projectId}`); };
  const goPlan = () => { if (!isPlan) nav(`/my-projects/${projectId}/plan`); };
  return (
    <div className="pvt-seg" role="tablist" data-testid="pvt-toggle">
      <div
        role="tab"
        aria-selected={isDelivery}
        className={isDelivery ? 'on' : ''}
        data-testid="pvt-delivery"
        onClick={goDelivery}
      >Delivery</div>
      <div
        role="tab"
        aria-selected={isPlan}
        className={isPlan ? 'on' : ''}
        data-testid="pvt-plan"
        onClick={goPlan}
      >Plan</div>
    </div>
  );
}
